const href = '/styles/antd-mobile.min.css';
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute('href', href);
document.head.appendChild(link);
export * from "node_modules/antd-mobile";
